export const DEFAULT_SYSTEM_RESOURCE_URLS = [
  'https://cdn.catalystglobal.games/resources/map-task.png',
  'https://cdn.catalystglobal.games/resources/map-task--complete.png',
  'https://stsharedappstorage.blob.core.windows.net/prod-catalyst-files/checked.png',
  'https://stsharedappstorage.blob.core.windows.net/prod-catalyst-files/cross.png'
];

export const DEFAULT_SYSTEM_RESOURCE_TEXTS = [
  'Congratulations, you got it!',
  'Well done, you are partially correct.',
  "That's not the answer!"
];

export const DEFAULT_SYSTEM_RESOURCE_NAME_PREFIX = 'Designer Setting - default';
